import { REFI_PERSONAL_CONST } from '../shared/constants/app.constants.js';
import { ApiService } from '../core/services/api/api.service.js';

export class _ApplicantsService {
  constructor() {
    this.applicantInfo = null;
    this.stips = null;
    this.eAppId = '';
  }

  getApplicantInformation(eAppId) {
    const [, , profileRefId] = document?.cookie?.match(
      '(^|;) ?C1_PRID=([^;]*)(;|$)'
    ) || ['', '', ''];
    const headers = REFI_PERSONAL_CONST.HTTP_HEADERS;
    headers.profileReferenceId = profileRefId;

    if (!this.applicantInfo || this.eAppId !== eAppId) {
      const url = REFI_PERSONAL_CONST.GET_APPLICANTS_INFORMATION_URL(eAppId);
      this.applicantInfo = ApiService.get(
        url,
        headers,
        REFI_PERSONAL_CONST.TIMEOUT_IN_MS
      );
      this.eAppId = eAppId;
    }

    return this.applicantInfo;
  }

  async getStips(eAppId) {
    const headers = REFI_PERSONAL_CONST.HTTP_HEADERS;

    if (!this.stips || this.eAppId !== eAppId) {
      const url = REFI_PERSONAL_CONST.GET_APPLICATION_TASKS_URL(eAppId);
      this.stips = ApiService.get(
        url,
        headers,
        REFI_PERSONAL_CONST.TIMEOUT_IN_MS
      );
      this.eAppId = eAppId;
    }

    return this.stips;
  }

  updateApplicantInformation(eAppId, applicantId, applicantInfo) {
    const [, , profileRefId] = document?.cookie?.match(
      '(^|;) ?C1_PRID=([^;]*)(;|$)'
    ) || ['', '', ''];
    const headers = REFI_PERSONAL_CONST.HTTP_HEADERS;
    headers.profileReferenceId = profileRefId;

    const url = REFI_PERSONAL_CONST.PATCH_APPLICANTS_INFORMATION_URL(
      eAppId,
      applicantId
    );

    this.applicantInfo = null;
    this.eAppId = '';
    return ApiService.patch(
      url,
      applicantInfo,
      headers,
      REFI_PERSONAL_CONST.TIMEOUT_IN_MS
    );
  }
}

export const ApplicantsService = new _ApplicantsService();
